import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import SingleContainerization from './SingleContainerization';
import { resetContainerState } from 'src/store/common-slices/getContainerSlice';
import { BatchMoveContainersPages, setPageToRender } from 'src/store/common-slices/batchMoveContainersSlice';

const mapStateToProps = (state: RootState) => ({
    pageToRender: state.BatchMoveContainers.pageToRender
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    resetContainerState: () => dispatch(resetContainerState()),
    setPageToRender: (pageToRender: BatchMoveContainersPages) => dispatch(setPageToRender(pageToRender)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleContainerization)